jQuery(document).ready(function ($) {

  /* All homepage carousels sit below the fold, so their Swiper inits are
     deferred until the carousel is near the viewport (300px early). This moves
     ~1-2s of Script Evaluation + the forced layouts out of the initial-load
     TBT window. Fallback: init immediately where IO is unsupported. */
  function initNearView(el, init) {
    if (!el) return;
    if (!('IntersectionObserver' in window)) { init(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { io.disconnect(); init(); }
    }, { rootMargin: '300px 0px' });
    io.observe(el);
  }

  initNearView(document.querySelector('.swiper-index-2026-ups'), function () {
    new Swiper('.swiper-index-2026-ups', {
      slidesPerView: 1.10,
      spaceBetween: 21,
      autoHeight: false,
      autoplay: false,   // ← disables autoplay

      breakpoints: {
        768: {
          slidesPerView: 4
        }
      }

    });
  });


  initNearView(document.querySelector('.swiper-index-2026-slides'), function () {
    new Swiper('.swiper-index-2026-slides', {
      slidesPerView: 1.6,
      spaceBetween: 15,
      autoHeight: false,
      autoplay: false,   // ← disables autoplay

      breakpoints: {
        768: {
          slidesPerView: 5,
          spaceBetween: 32,
        }
      }

    });
  });


// var swiperLogos = new Swiper('.index-2026-logos', {
//   slidesPerView: 8,            // desktop default
//   spaceBetween: 20,            // spacing for desktop
//   loop: true,                  // infinite loop
//   speed: 5000,                 // scroll speed for freeMode
//   freeMode: true,              // allows continuous scrolling
//   freeModeMomentum: false,     // prevent snapping
//   autoplay: {
//     delay: 0,                  // continuous, no pause
//     disableOnInteraction: false,
//   },
//   // DISABLE ALL USER INTERACTION
//   allowTouchMove: false,       // no drag / swipe
//   simulateTouch: false,
//   grabCursor: false,
//   breakpoints: {
//     320: { 
//       slidesPerView: 'auto',   // variable width logos on mobile
//       spaceBetween: 15,
//       freeMode: true,          // continuous scroll
//       speed: 4000              // adjust scroll speed for mobile
//     },
//     640: { 
//       slidesPerView: 'auto', 
//       spaceBetween: 20,
//       freeMode: true,
//       speed: 4500
//     },
//     1024: { 
//       slidesPerView: 7.2,     // larger desktop tablet
//       spaceBetween: 20,
//       freeMode: false,         // snapping for desktop
//       speed: 5000
//     },
//     1280: {
//       slidesPerView: 8,        // full desktop
//       spaceBetween: 20,
//       freeMode: false,
//       speed: 5000
//     }
//   },
// });


  // Experts carousel: the widest breakpoint shows 3.9 per view, and Swiper's loop
  // needs slides >= 2 x slidesPerView (>= 8 here). With fewer, it logs
  // "not enough slides for loop mode" and disables loop, so gate loop on the count.
  var expertsEl = document.querySelector('.swiper-index-2026-experts');
  initNearView(expertsEl, function () {
    var expertsSlides = expertsEl.querySelectorAll('.swiper-slide').length;
    var swiperIngredientExperts = new Swiper('.swiper-index-2026-experts', {
        slidesPerView: 1.1,
        spaceBetween: 22,
        autoHeight: false,
        loop: expertsSlides >= 8, // ← only loop when there are enough slides for the widest view
        autoplay: {
            delay: 3000, // 3 seconds between slides
            disableOnInteraction: false, // continue autoplay after user interaction
        },

        breakpoints: {
          768: {
            slidesPerView: 1.1
          },
          1040: {
            slidesPerView: 2.6
          },
          1366: {
            slidesPerView: 2.8
          },
          1600: {
            slidesPerView: 3.4
          },
          1700: {
            slidesPerView: 3.9
          }
        }
    });
  });


  // Loop over each slider — each one lazy-inits as it nears the viewport
  $('.swiper-gift-card-reviews-slider').each(function (index, slider) {
    initNearView(slider, function () {
        const $slider = $(slider);
        const $wrapper = $slider.find('.swiper-wrapper');
        const $slides = $wrapper.children().toArray();

        // Shuffle slides once before initializing Swiper
        shuffleArray($slides).forEach(slide => $wrapper.append(slide));

        // Initialize Swiper — only loop/autoplay when there are enough slides
        // (loop mode with slidesPerView:1 needs >= 2 slides, else Swiper warns + disables it)
        const slideCount = $slides.length;
        const swiperInstance = new Swiper(slider, {
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            // rewind (not loop): fade + loop warns "not enough slides" and needs
            // duplicate slides; rewind wraps to the first slide with any count.
            rewind: slideCount > 1,
            speed: 700,
            autoplay: slideCount > 1 ? { delay: 4000, disableOnInteraction: false } : false,
            // observeParents: true,
        });
    });
  });

    // Fisher-Yates shuffle function
  function shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
  }


  $('.index-2026-tabs [data-product]').on('click', function () {

      const product = $(this).data('product');


      // toggle active tab
      $('.index-2026-tabs [data-product]').removeClass('active');
      $(this).addClass('active');

      // toggle matching slide
      $('.swiper-index-2026-slides[data-product]').removeClass('active');
      $('.swiper-index-2026-slides[data-product="' + product + '"]').addClass('active');

  });

  // $('.pick-product').on('click', function () {
  //   $('.pick-product').removeClass('active');
  //   $(this).addClass('active');

  //   $('.pick-product-cta-container').removeClass('active');
  //   $('.pick-product-cta-container[data-product="'+$(this).data('product')+'"]').addClass('active');

  //   $('.swiper-gift-card-reviews-slider').each(function (index, slider) {
  //     const $slider = $(slider);
  //     const $wrapper = $slider.find('.swiper-wrapper');
  //     const $slides = $wrapper.children().toArray();

  //     // Shuffle slides
  //     shuffleArray($slides).forEach(slide => $wrapper.append(slide));

  //     // Check if Swiper is already initialized and destroy it
  //     if ($slider[0].swiper) {
  //         $slider[0].swiper.destroy(true, true);
  //     }

  //     // Initialize Swiper
  //     const swiperInstance = new Swiper(slider, {
  //         slidesPerView: 1,
  //         effect: 'fade',
  //         fadeEffect: { crossFade: true },
  //         loop: true,
  //         speed: 700,
  //         autoplay: { delay: 4000, disableOnInteraction: false },
  //         observeParents: true,
  //     });
  // });

  // });


  $('#expand-comparison-table').on('click', function () {

    var el = $(this);

    $(this).toggleClass('active');

    if ($(this).hasClass('active')){
      $('.slide-up-table-comparison').addClass('expanded');
      $(this).find('span').html('Click To Close');
      $(this).hide();

      setTimeout(function(){
        el.fadeIn();
      },2000);

    }else{

      
      // $('.slide-up-table-comparison').removeClass('expanded');

      // const $target = $('.section-index-2026-compare');
      // $('html, body').animate({
      //     scrollTop: $target.offset().top - 100
      // }, 1300);   // change speed if needed

      const $target = $('.section-index-2026-compare');
      el.hide();

      $('html, body').animate(
        {
          scrollTop: $target.offset().top - 100
        },
        1300,
        function () {
          $('.slide-up-table-comparison').removeClass('expanded');
          el.find('span').html('Click To Expand');
          setTimeout(function(){
            el.fadeIn();
          },2000);
        }
      );


    }
    
  });

  $('.why-item-wrapper').on('click', function () {
    $('.why-item-wrapper').not($(this)).removeClass('active');
    $(this).toggleClass('active');
  });


  // $('#compare').on('click', function () {
  //   $(this).hide();
  //   $('.expanded-click-and-compare').addClass('active');

  //   const $target = $('.expanded-click-and-compare');
  //   $target.addClass('active');

  //   $('html, body').animate({
  //       scrollTop: $target.offset().top - 100
  //   }, 600);   // change speed if needed

  // });


  const phrases = [
    "Build Lean Muscle",
    "Age On Your Terms",
    "Burn Fat & Recover",
    "First or Nothing"
  ];

  const element = document.querySelector(".section-index-2026-hero h1 .d-block");

  // Rotate only for real visitors: automation (Lighthouse/PSI/headless sets
  // navigator.webdriver) gets the static headline so lab traces stay clean.
  if (element && !navigator.webdriver) {

  element.classList.add("fade-text");

  let index = 0;

  function changeText() {

    element.classList.add("hidden"); // fade out

    setTimeout(() => {

      index = (index + 1) % phrases.length;
      element.textContent = phrases[index];

      element.classList.remove("hidden"); // fade in

      const delay = (phrases[index] === "First or Nothing") ? 7000 : 3500;
      setTimeout(changeText, delay);

    }, 250); // match CSS (0.25s)
  }

  setTimeout(changeText, 2500);

  }
    


});